import classNames from 'classnames';
import type { ReactNode } from 'react';
import type { Form } from 'state/secondaryMarket/shared/form/form.model';
import type { SecondaryMarketFormError } from 'state/secondaryMarket/shared/form/validationResults';

import { ErrorItem } from './ErrorItem';
import { useErrorMessagesFormatter } from './useErrorMessageFormatter';
import type { ColorSeverityMapper, TranslatedErrorMessage } from './useTranslatedErrorMessage';

export type ErrorsPanelProps<F = Form> = {
  e2e: string;
  className?: string;
  errors?: readonly SecondaryMarketFormError<F>[];
  colorToSeverity?: ColorSeverityMapper;
  messagesToDisplay?: readonly TranslatedErrorMessage[];
  children?: ReactNode;
};

export function MessagesPanel<F = Form>({
  e2e,
  className,
  errors,
  colorToSeverity,
  messagesToDisplay,
  children,
}: ErrorsPanelProps<F>) {
  const messages = useErrorMessagesFormatter<F>(errors, colorToSeverity);
  return (
    <div className={classNames('w-100 overflow-auto', className)} data-e2e={e2e}>
      {(messagesToDisplay ?? messages).map(({ htmlMessage, severity, id }, idx) => (
        <ErrorItem key={id} index={idx} htmlMessage={htmlMessage} severity={severity} />
      ))}
      {children}
    </div>
  );
}
